import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import "../../../style/about/developmentConcernBackground.css";
import Fade from "react-reveal/Fade";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const DevelopmentConcernBackground = () => {
  useEffect(() => {
    document.title = `Development Concern | Development Concern Background`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/about/ashroy-angon-background";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="background_section">
        <div className="header_image">
          <p>Home | About</p>
          <h3>History Of</h3>
          <h2>Development Concern</h2>
        </div>

        <div className="container">
          {/* Social Share Section Start */}
          {/* <div className="social_share_button">
            <FacebookShareButton
              url={shareUrl}
              target={"_blank"}
              quote={"share facebook"}
              hashtag={"#facebook"}
            >
              <FacebookIcon size={35} round={true} />
            </FacebookShareButton>
            <TwitterShareButton
              url={shareUrl}
              target={"_blank"}
              quote={"share twitter"}
              hashtag={"#twitter"}
            >
              <TwitterIcon size={35} round={true} />
            </TwitterShareButton>
            <LinkedinShareButton
              url={shareUrl}
              target={"_blank"}
              quote={"share linkedin"}
              hashtag={"#linkedin"}
            >
              <LinkedinIcon size={35} round={true} />
            </LinkedinShareButton>
          </div> */}
          {/* Social Share Section End */}

          <h2>History Of Development Concern</h2>

          <div className="content_wrapper">
            <div className="content">
              <Fade bottom duration={2000}>
                <p>
                  Development Concern (DC) is an NGO based in Rangamati focusing on development and research. It was established in the year 2005 by a group of highly educated and energetic young social workers with commitment of providing development support to the indigenous people living in the Chittagong Hill Tracts (CHT). Development Concern has a governing body comprising of 21 members who are working as volunteer to achieve the ultimate objectives of the organization with its vision and mission.
                </p>
              </Fade>

              <Fade bottom duration={2000}>
                <p className="for_margin">
                  The CHT covering Rangamati, Khagrachari and Bandarban is situated in the south-eastern part of Bangladesh most of which are hill terrain. There live thirteen indigenous communities in the CHT. The socio-economic condition of the hilly region is rather vulnerable, despite there are development initiatives by a number of development organizations, most of the people still live under poverty line. The reason behind their backwardness is very obvious. The CHT was deprived of development interventions addressing the problems of people living therein since independence. Consequently, they have still no access to basic human needs such as education, nutrition, health facilities and so on. Against this backdrop, Development Concern (DC) emerged with a view to fostering development to the residents of the region.
                </p>
              </Fade>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DevelopmentConcernBackground;
